import { FileExcelOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, DatePicker, Form, PageHeader, Space } from 'antd';
import moment from 'moment';
import React from 'react';
import { Props } from '.';
import { defaultFormat } from '../../config/constants';
import { translations } from '../../config/translations';
import { downloadFile } from '../../helpers/FileHelper';
import { PeopleScheduleClient, PeopleScheduleXslxTypeEnum } from '../../utils/api';

interface State {
    isExporting: boolean;
    isExportingByAccommodation: boolean;
}

class PeopleSchedule extends React.Component<Props, State> {
    formRef = React.createRef<any>();

    public constructor(props: Props) {
        super(props);
        this.state = {
            isExporting: false,
            isExportingByAccommodation: false,
        };
    }

    private handleExport = async () => {
        if (!this.formRef.current) return;
        const values = this.formRef.current.getFieldsValue();
        this.setState({ isExporting: true });

        let result = await new PeopleScheduleClient().generateXlsx(
            values.date,
            PeopleScheduleXslxTypeEnum.ByDefault
        );

        downloadFile(result);
        this.setState({ isExporting: false });
    };

    private handleExportByAccommodation = async () => {
        if (!this.formRef.current) return;
        const values = this.formRef.current.getFieldsValue();
        this.setState({ isExportingByAccommodation: true });

        let result = await new PeopleScheduleClient().generateXlsx(
            values.date,
            PeopleScheduleXslxTypeEnum.ByAccomodation
        );

        downloadFile(result);
        this.setState({ isExportingByAccommodation: false });
    };

    public render(): React.ReactNode {
        const { isExporting, isExportingByAccommodation } = this.state;

        return (
            <>
                <PageHeader title={translations.peopleSchedule.title} />
                <Form
                    ref={this.formRef}
                    initialValues={{
                        date: moment(new Date()),
                    }}
                >
                    <Form.Item name="date" label={translations.workHourRecods.form.date}>
                        <DatePicker
                            placeholder={translations.general.chooseDate}
                            format={defaultFormat}
                        />
                    </Form.Item>

                    <Space>
                        <Button
                            onClick={this.handleExport}
                            disabled={isExporting || isExportingByAccommodation}
                        >
                            {isExporting ? <SyncOutlined spin /> : <FileExcelOutlined />}
                            {translations.general.export}
                        </Button>
                        <Button
                            onClick={this.handleExportByAccommodation}
                            disabled={isExporting || isExportingByAccommodation}
                        >
                            {isExportingByAccommodation ? (
                                <SyncOutlined spin />
                            ) : (
                                <FileExcelOutlined />
                            )}
                            {translations.general.exportByAccommodation}
                        </Button>
                    </Space>
                </Form>
            </>
        );
    }
}

export default PeopleSchedule;
